import { Button } from '@medely/ui-kit';
import { BottomSheetDialog } from '@medely/web-components';
import useDevice from '@mp/hooks/useDevice.web';
import React from 'react';
import { ReleaseShiftModalProps } from './interface';
import { ReleaseShiftModalInfo } from './ReleaseShiftModalInfo';
import { useReleaseShift } from './useReleaseShift';

export const ReleaseShiftModal = ({
  open,
  onClose,
  jobId,
  releaseOptions,
  locationId,
}: ReleaseShiftModalProps) => {
  const isDesktop = useDevice() === 'desktop';
  const {
    getTitle,
    setReleaseStatus,
    releaseStatus,
    releaseStep,
    setReleaseStep,
    handleClick,
    buttonLabel,
    isButtonLoading,
    getRequesteeId,
    disableContinueButton,
  } = useReleaseShift({ jobId, onClose });

  const height = '55vh';

  const handleClose =
    releaseStep === 'prosToSwap' ? () => setReleaseStep('releaseOptions') : onClose;

  return (
    <BottomSheetDialog
      open={open}
      onClose={handleClose}
      title={getTitle()}
      sx={{
        alignSelf: isDesktop ? 'center' : 'end',
        ...(isDesktop ? {} : { height: height, mt: 'auto' }),
      }}
      content={
        <ReleaseShiftModalInfo
          handleStatusChange={setReleaseStatus}
          currentStatus={releaseStatus}
          currentStep={releaseStep}
          releaseOptions={releaseOptions}
          getRequesteeId={getRequesteeId}
          jobId={jobId}
          locationId={locationId}
        />
      }
      actions={
        releaseStatus !== null && (
          <Button
            onClick={handleClick}
            disabled={disableContinueButton || isButtonLoading}
            loading={isButtonLoading}
            fullWidth
          >
            {buttonLabel()}
          </Button>
        )
      }
      isDesktop={isDesktop}
    />
  );
};
